// Used by backend team to redirect endpoints to local environment
const BACKEND_LOCALHOST = 'localhost:3080';
const BACKEND_LOCALHOST_STRIPE_API_KEY =
  'pk_test_51RtY8m2MEXpsTQUjBEYSpLPkck6xrlkMf5hgLaxJgjCp0XrnPy4JEjXnnO41tRyd7VlP4PHumDfGXUXxC92tILEk00HBt6ZRk4';

export const isBackendLocalhost = document.location.host === BACKEND_LOCALHOST;

export const mainConfig = {
  BASE_URL_PREFIX: '',
  API_URL: import.meta.env.VITE_API_URL,
  RECAPTCHA_SITE_KEY: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
  AMPLITUDE_API_KEY: import.meta.env.VITE_AMPLITUDE_API_KEY,
  LANDING_URL: import.meta.env.VITE_LANDING_URL,
  TERMS_AND_CONDITIONS_URL: import.meta.env.VITE_TERMS_AND_CONDITIONS_URL,
  COOKIES_POLICY_URL: import.meta.env.VITE_COOKIES_POLICY_URL,
  SUPPORT_EMAIL_URL: import.meta.env.VITE_SUPPORT_EMAIL_URL,
  RELEASE_VERSION: import.meta.env.VITE_RELEASE_VERSION,
  BUILD_VERSION: import.meta.env.VITE_BITBUCKET_BUILD_NUMBER,
  SENTRY_DSN_KEY: import.meta.env.VITE_SENTRY_DSN_KEY,
  PEPPER_PAY_API_KEY: import.meta.env.VITE_PEPPER_PAY_API_KEY,
  ENV_NAME: import.meta.env.VITE_ENV_NAME,
  PEPPER_PAY_SANDBOX_URL: import.meta.env.VITE_PEPPER_PAY_SANDBOX_URL,
  ELEVEN_LABS_KEY: import.meta.env.VITE_ELEVEN_LABS_KEY,
  PRIVACY_POLICY_URL: import.meta.env.VITE_PRIVACY_POLICY_URL,
  STRIPE_API_KEY: import.meta.env.VITE_STRIPE_API_KEY,
};

const getConfig = () => {
  let currentConfig = {};

  if (isBackendLocalhost) {
    currentConfig = {
      API_URL: `http://${BACKEND_LOCALHOST}/api`,
      STRIPE_API_KEY: BACKEND_LOCALHOST_STRIPE_API_KEY,
    };
  }

  return {
    ...mainConfig,
    ...currentConfig,
    IS_DEVELOPMENT: mainConfig.ENV_NAME === 'development' || mainConfig.ENV_NAME === 'qa',
    IS_STAGING: mainConfig.ENV_NAME === 'staging',
  };
};

export const envConfig = getConfig();
